import React from 'react'
import { useDispatch } from 'react-redux'
import { BpButton } from '../../../../shared/components/buttons/bp-button/BpButton'
import { usePostLanguageComplianceUpdateStateMutation } from '../../../../app/api'
import { useTranslation } from 'react-i18next'
import { showAlert } from '../../../../app/store/reducers/AppSlice'

interface ResolveButtonCellProps {
  url: string
  project: string
  country: string
  onResolve: () => void
}

export const ResolveButtonCell = ({ url, project, country, onResolve }: ResolveButtonCellProps) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [updateState] = usePostLanguageComplianceUpdateStateMutation()

  return (
    <BpButton
      size={'sm'}
      theme={'outline'}
      onClick={() => {
        updateState({
          stateForm: {
            project_id: Number(project),
            country_id: country,
            urls: [url],
            state: 'resolved',
          },
        }).then(() => {
          dispatch(
            showAlert({
              message: t('notifications.reportMoved'),
              type: 'success',
              timeout: 2000,
            }),
          )
          onResolve()
        })
      }}
    >
      Resolve
    </BpButton>
  )
}
